let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aVX5e")).then(() => parcelRequire('aDBI2'));